import type { FinalReviewSection } from '../../../../services/finalReview';

interface DesignLoopActions {
    submitTypes: string[];
    unchangedAction: string;
    handBackActions: Readonly<Record<FinalReviewSection, string>>;
}

const DESIGN: DesignLoopActions = {
    submitTypes: ['submit-design-plan'],
    unchangedAction: 'design-unchanged',
    handBackActions: { design: 'hand-back-design', dx: 'hand-back-dx' }
};

// Redesign runs the same screens under its own action ids; a redesigned case's history starts in Design.
const REDESIGN: DesignLoopActions = {
    submitTypes: ['submit-design-plan', 'submit-redesign'],
    unchangedAction: 'redesign-unchanged',
    handBackActions: { design: 'redesign-hand-back-design', dx: 'redesign-hand-back-dx' }
};

export function designLoopActions(macro: string): DesignLoopActions {
    return macro === 'redesign' ? REDESIGN : DESIGN;
}
